import React from "react";
import emaarLogo from './emaar-properties-white-1-YbN91x93e4Ure0RE.avif';
import paymentPlan from './radisson-event-6-A854N9eLQ6s82r09.avif';
import planPdf from './payment plan (1).pdf';
import amenitiesImg from './3-1.jpeg';
import { FaCircleCheck } from "react-icons/fa6";
import { HiMiniBuildingLibrary } from "react-icons/hi2";
import { CgGym } from "react-icons/cg";
import { FaSwimmingPool } from "react-icons/fa";
import { FaGamepad } from "react-icons/fa";
import { MdDoorSliding } from "react-icons/md";
import { FaFire } from "react-icons/fa";
import { PiSecurityCameraFill } from "react-icons/pi";
import { GiPowerLightning } from "react-icons/gi";
import { PiThermometerHotFill } from "react-icons/pi";



import './park-edge.css';

const ParkEdge = () => {

    const sectionScrollHandler = (sectionId) => {
        const section = document.getElementById(sectionId);

        if (section) {
            window.scrollTo({
                top: section.offsetTop,
                behavior: "smooth"
            });
        };
    };

    const handleDownload = () => {
        const link = document.createElement('a');
        link.href = planPdf;
        link.download = 'Emaar ParkEdge - Payment Plan.pdf';  // Set the download filename here
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <>
            {/* home... */}
            <section id="park_edge_bg">
                <div id="park_edge_home">
                    <img src={emaarLogo} alt="emaar parkedge" />
                    <h1 id="park_edge_main_hdng">
                        Park Edge
                    </h1>
                    <p id="park_edge_main_txt">
                        A Premium Lifestyle In DHA Phase 8
                    </p>
                    <button
                        onClick={() => sectionScrollHandler('park_edge_contact')}
                        className="project_btn" id="park_edge_home_btn">
                        Booking & Details
                    </button>
                </div>
            </section>


            {/* about... */}
            <section id="park_edge_about">
                <div id="park_edge_about_hdng">
                    Escape To A New Level Of Luxury At
                    <b>Emaar Park Edge</b>
                </div>
                <div id="park_edge_about_txt" >
                    Rising like a beacon within the prestigious Emaar Oceanfront Community, Park Edge offers more than just a residence – it's a gateway to an unparalleled lifestyle. Imagine waking up to stunning sunrises over the Arabian Sea, surrounded by lush greenery and tranquility. Park Edge promises perfect harmony between the elegance of modern design and the timeless beauty of nature.
                    <span>Expected Completion: <b>2028</b>
                        <br />
                        <b>10%</b> Downpayment & <b>Quarterly</b> Instalments
                    </span>
                </div>
            </section>

            <section id="park_edge_features">
                <div id="park_edge_features_div">
                    <h2 id="park_edge_features_hdng">
                        Key Features & Payment Plan
                    </h2>

                    <div id="park_edge_features_points">
                        <span>
                            <FaCircleCheck style={{ color: '#1D1E20', fontSize: '25px', marginRight: '10px' }} />
                            1-4 Bedroom Apartments, Signature Duplexes & Penthouse
                        </span>
                        <span>
                            <FaCircleCheck style={{ color: '#1D1E20', fontSize: '25px', marginRight: '10px' }} />
                            Twin Tower Project
                        </span>
                        <span>
                            <FaCircleCheck style={{ color: '#1D1E20', fontSize: '25px', marginRight: '10px' }} />
                            G+41 Floors
                        </span>
                        <span>
                            <FaCircleCheck style={{ color: '#1D1E20', fontSize: '25px', marginRight: '10px' }} />
                            6 Levels Of Car Parking
                        </span>
                        <span>
                            <FaCircleCheck style={{ color: '#1D1E20', fontSize: '25px', marginRight: '10px' }} />
                            33% Construction Done
                        </span>
                    </div>
                </div>
                <div id="park_edge_payment_plan_div">
                    <img id="park_edge_payment_plan" src={paymentPlan} alt="payment plan" />
                    <button
                        onClick={handleDownload}
                        id="park_edge_payment_btn">
                        Download Plan
                    </button>
                </div>
            </section>

            <section id="park_edge_amenities">
                <img src={amenitiesImg} id="park_edge_amenities_img">
                </img>
                <div id="park_edge_amenities_content">
                    Dive into a world of comfort and convenience. Explore our extensive range of features and amenities, designed to cater to your every need and elevate your lifestyle.

                    <div id="park_edge_amenities_icn_div">
                        <span style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', fontSize: '14px', gap: '5px', paddingTop: '40px' }}>
                            <HiMiniBuildingLibrary style={{ fontSize: '50px' }} />
                            Multiple Gathering halls
                        </span>

                        <span style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', fontSize: '14px', gap: '5px', paddingTop: '40px' }}>
                            <CgGym style={{ fontSize: '50px' }} />
                            GYM & Fitness
                        </span>

                        <span style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', fontSize: '14px', gap: '5px', paddingTop: '40px' }}>
                            <FaSwimmingPool style={{ fontSize: '50px' }} />
                            Infinity Pools
                        </span>

                        <span style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', fontSize: '14px', gap: '5px', paddingTop: '40px' }}>
                            <FaGamepad style={{ fontSize: '50px' }} />
                            Gaming Rooms
                        </span>

                        <span style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', fontSize: '14px', gap: '5px', paddingTop: '40px' }}>
                            <MdDoorSliding style={{ fontSize: '50px' }} />
                            Built-In Wardrobes
                        </span>

                        <span style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', fontSize: '14px', gap: '5px', paddingTop: '40px' }}>
                            <FaFire style={{ fontSize: '50px' }} />
                            Fire-Safety System
                        </span>

                        <span style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', fontSize: '14px', gap: '5px', paddingTop: '40px' }}>
                            <PiSecurityCameraFill style={{ fontSize: '50px' }} />
                            CCTV Surveillance
                        </span>

                        <span style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', fontSize: '14px', gap: '5px', paddingTop: '40px' }}>
                            <GiPowerLightning style={{ fontSize: '50px' }} />
                            24/7 Power Backup
                        </span>

                        <span style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', fontSize: '14px', gap: '5px', paddingTop: '40px' }}>
                            <PiThermometerHotFill style={{ fontSize: '50px' }} />
                            Electric Geysers
                        </span>
                    </div>
                </div>
            </section>




        </>
    );
};

export default ParkEdge;